import t from "../../../../helpers/t";
import React from "react";

const DiscountPrice = (props) => {
  const { priceLocal, onChangeForm } = props;
  return (
    <>
      <td className="weekday_price">
        <input
          className="pricetariff-price input-group-field weekpricefield"
          type="text"
          name="discount_valid_from"
          value={
            typeof priceLocal.discount_valid_from !== "undefined" &&
            priceLocal.discount_valid_from !== null &&
            priceLocal.discount_valid_from !== 0
              ? priceLocal.discount_valid_from / 86400
              : 0
          }
          onChange={(e) => onChangeForm(e)}
          style={{ float: "left", width: "25%", marginLeft: "5px" }}
        />
        <label style={{ marginLeft: "5px" }}>{t("days")}</label>
      </td>
    </>
  );
};

export default DiscountPrice;
